<div>
    <footer class="d-flex flex-wrap justify-content-between align-items-center py-3 border-top container-fluid">
        <div class="col-md-4 d-flex align-items-center">
            <a href="/" class="mb-3 me-2 mb-md-0 text-muted text-decoration-none lh-1">
                <img [src]="logo_url" style="height: 25px;" alt="logo">
            </a>
            <span class="mb-3 ml-2 mb-md-0 text-muted">© {{year}} Gospel Echoing Missionary Society (GEMS).</span>
        </div>

        <ul class="nav col-md-4 justify-content-end list-unstyled d-flex">
            <li>Developed By
                <a href="https://agoo.in">
                    <img src="assets/images/agoo_logo.png" style="height: 25px;" alt="logo">
                </a>
            </li>
        </ul>
    </footer>
</div>